import { isReloading, reload } from "@/error/reload";
import { technicalUser } from "@/model/user";

import type { UserResponse } from "./serverModel";

/** True when the refreshed identity no longer matches the running session. */
export async function identityChanged(response: UserResponse): Promise<boolean> {
  // Loaded lazily: api.config.ts calls this, and the user store reaches
  // api.config.ts again through http/user, so a static import would be a cycle.
  const { useUserStore } = await import("@/store/user");
  const current = useUserStore().technicalUser;
  if (!current.id) {
    return false;
  }
  // Normalized like loadSession did for the running session, so an unknown role
  // compares as "observer" on both sides instead of reloading on every refresh.
  const refreshed = technicalUser(
    response.user_id,
    response.company,
    response.role,
    response.nats_subject_scheme ?? "v1",
  );
  return refreshed.natsScheme !== current.natsScheme || refreshed.role !== current.role;
}

/** Reloads when the identity moved so the session comes back on the new scheme and role. */
export async function reloadIfIdentityChanged(response: UserResponse): Promise<boolean> {
  const changed = await identityChanged(response);
  if (changed && !isReloading()) {
    reload("refresh-token");
  }
  return changed;
}
